export default {
  props: ["signedInUser", "data"],

  data() {
    return {
      activeItem: null,
    };
  },

  mounted() {
    this.setActiveItem(0);
  },

  computed: {
    menuColumns,
  },

  methods: {
    setActiveItem,
    handleParentClick: function (data) {
      if (data.name === "Gifts") {
        this.$router.push({
          name: "ParentCollection",
          params: {
            collectionName: data.name,
            collectionId: data.id,
          },
        });
      } else {
        this.$router.push({
          name: "productsFromNavigation",
          params: {
            navItemName: data.name,
            navItemId: data.id,
          },
          query: {
            sortBy: "created_at_asc",
            page: 1,
          },
        });
      }

      this.$ma.trackEvent({
        action: "Navigation Click",
        properties: {
          "Page Title": data.name,
          "Page Type": data.type,
        },
      });
      this.$store.dispatch("navigation/setDropdownType", "closed");
    },
    handleChildClick: function (data) {
      if (data.type === "COLLECTION") {
        this.$router.push({
          name: "CollectionWithCategory",
          params: {
            categoryName: data.parentName,
            collectionName: data.name,
            collectionId: data.id,
          },
        });
      } else if (data.type === "CATEGORY") {
        this.$router.push({
          path: `/${this.$utils.urlSafeString(data.parentName)}/${this.$utils.urlSafeString(data.name)}/${
            data.entity_id
          }/products`,
        });
      }

      this.$ma.trackEvent({
        action: "Navigation Click",
        properties: {
          "Page Title": data.name,
          "Page Type": data.type,
        },
      });
      this.$store.dispatch("navigation/setDropdownType", "closed");
    },
    handleCollectionClick: function (parentName, name, collectionId) {
      this.$router.push({
        name: "CollectionWithCategory",
        params: {
          categoryName: parentName,
          collectionName: name,
          collectionId: collectionId,
        },
      });
      this.$store.dispatch("navigation/setDropdownType", "closed");
      this.$ma.trackEvent({
        action: "Navigation Click",
        properties: {
          "Page Title": name,
          "Page Type": "collection",
        },
      });
    },
  },

  watch: {
    data() {
      this.setActiveItem(0);
    },
  },
};

function setActiveItem(index) {
  if (this.data && this.data.children_containers) {
    this.activeItem = this.data.children_containers[index];
  }
}

function menuColumns() {
  if (this.activeItem === null) return;

  const computedActiveItem = { ...this.activeItem };

  if (this.activeItem.container_direction === "GRID") {
    computedActiveItem.children_containers = computedActiveItem.children_containers.map((container) => {
      return {
        ...container,
        view_components: [
          {
            id: container.id,
            info: {
              layout: "CATEGORY_LABEL",
              text: container.name,
            },
          },
          ...container.view_components.map((component) => ({
            ...component,
            info: {
              ...component.info,
              parent_name: container.name,
            },
          })),
        ],
      };
    });
  } else {
    //hiding IMAGE collections until endpoint changes
    computedActiveItem.children_containers = computedActiveItem.children_containers.filter(
      (container) => container.view_components.length !== 2
    );
  }
  return computedActiveItem;
}
